import React from 'react';
import {MeetingTabs} from './components/MeetingTabs';
import {InvitationDataGrid} from './components/InvitationDataGrid';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {
  accountNameColumn,
  dateSentOnColumn,
  ownerColumn,
  meetingHostColumn,
  sentByColumn,
  clientsColumn,
  propositionTypeColumn,
  rtqStatusColumn,
  ecqStatusColumn,
} from './invitationColumns';
import {InvitationFilters} from './InvitationFilters';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {InvitationFormSchema, InvitationPageProps} from './invitationFormProps';
import {useInvitationState} from './hooks/useInvitationForm';
import {useLocalStorage} from '../../hooks/useLocalStorage';

const InvitedInner: React.FC = () => {
  const {values} = useInvitationState('invited');

  // DataGrid columns - using imported column definitions
  const columns = [
    accountNameColumn,
    clientsColumn,
    ownerColumn,
    meetingHostColumn,
    propositionTypeColumn,
    dateSentOnColumn,
    sentByColumn,
    rtqStatusColumn(true),
    ecqStatusColumn(true),
  ];

  return (
    <>
      <InvitationFilters includeATR includeECQ />
      <InvitationDataGrid
        inviteStatus={InvitationReviewsInput.INVITED}
        staff={values?.staff}
        ecqStatus={values?.ecqStatus}
        atrStatus={values?.atrStatus}
        search={values?.search}
        columns={columns}
        entityName="invitations"
        noDataMessage="No invitations found"
      />
    </>
  );
};

const InvitedWrapped = withAutoFormNew<InvitationFormSchema, InvitationPageProps>(
  InvitedInner,
  undefined,
  {debugPosition: 'bottom'}
);

export const InvitedPage: React.FC = () => {
  const [initialValue] = useLocalStorage<InvitationFormSchema>('invited', {
    staff: '',
    search: '',
  });
  return (
    <>
      <MeetingTabs />

      <InvitedWrapped initialValueOverrides={initialValue} formFields={[]} />
    </>
  );
};
